export enum PerformanceCardsNamesEnum {
    goals = "goals",
    indicators = "indicators",
    projects = "projects",
    approvedProjects = "approvedProjects",
    pendingProjects = "pendingProjects",
    rejectedProjects = "rejectedProjects",
    onHoldProjects = "onHoldProjects",
    finishedProjects = "finishedProjects",
    lateProjects = "lateProjects",
    onGoingProjects = "onGoingProjects",
}

export interface IDashboardCard {
    id: PerformanceCardsNamesEnum,
    name: string,
    icon: string,
    count: number,
};

export const DashboardCards = [
    {
        id: PerformanceCardsNamesEnum.goals,
        icon: "fa-solid fa-bullseye f-right",
        arName: "الأهداف",
        enName: "Goals",
        count: 0
    },
    {
        id: PerformanceCardsNamesEnum.indicators,
        icon: "fa-solid fa-chart-line f-right",
        arName: "المؤشرات",
        enName: "Indicators",
        count: 0
    },
    {
        id: PerformanceCardsNamesEnum.projects,
        icon: "fa-solid fa-rocket f-right",
        arName: "المبادرات",
        enName: "Initiatives",
        count: 0
    },
    {
        id: PerformanceCardsNamesEnum.approvedProjects,
        icon: "fa-solid fa-check-circle f-right",
        arName: "المبادرات المعتمدة",
        enName: "Approved Initiatives",
        count: 0
    },
    {
        id: PerformanceCardsNamesEnum.pendingProjects,
        icon: "fa-solid fa-clock f-right",
        arName: "المبادرات قيد التقييم",
        enName: "Pending Initiatives",
        count: 0
    },
    {
        id: PerformanceCardsNamesEnum.rejectedProjects,
        icon: "fa-solid fa-times-circle f-right",
        arName: "المبادرات المرفوضة",
        enName: "Rejected Initiatives",
        count: 0
    },
    {
        id: PerformanceCardsNamesEnum.onHoldProjects,
        icon: "fa-solid fa-pause-circle f-right",
        arName: "المبادرات الموقوفة",
        enName: "On-Hold Initiatives",
        count: 0
    },
    {
        id: PerformanceCardsNamesEnum.finishedProjects,
        icon: "fa-solid fa-flag-checkered f-right",
        arName: "المبادرات المنجزة",
        enName: "Completed Initiatives",
        count: 0
    },
    {
        id: PerformanceCardsNamesEnum.onGoingProjects,
        arName: "المبادرات قيد التنفيذ",
        icon: "fa-solid fa-hourglass-half f-right",
        enName: "In-progress Initiatives",
        count: 0
    },
    {
        id: PerformanceCardsNamesEnum.lateProjects,
        icon: "fa-solid fa-clock-rotate-left f-right",
        arName: "المبادرات المتأخرة",
        enName: "Late Initiatives",
        count: 0
    }
] as {
    id: PerformanceCardsNamesEnum,
    icon: string,
    count: number,
    arName: string,
    enName: string,
}[];

export enum ProjectCardsNamesEnum {
    resources = "resource",
    risks = "risks",
    milestones = "milestones"
}